var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAwesomeLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.932,
    height: 20.494,
    viewBox: "0 0 17.932 20.494",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-lock",
    "data-name": "Icon awesome-lock",
    d: "M16.011,8.966H15.05V6.084a6.084,6.084,0,1,0-12.168,0V8.966H1.921A1.922,1.922,0,0,0,0,10.887v7.685a1.922,1.922,0,0,0,1.921,1.921H16.011a1.922,1.922,0,0,0,1.921-1.921V10.887A1.922,1.922,0,0,0,16.011,8.966Zm-4.163,0H6.084V6.084a2.882,2.882,0,0,1,5.764,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwesomeLock);
export default __webpack_public_path__ + "static/media/awesome-lock.836cabb15bd5ff9950d45ed7b95a8b4b.svg";
export { ForwardRef as ReactComponent };